
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index5eOmP0fFyLMeta } from "/opt/buildhome/repo/frontend/pages/index.vue?macro=true";
import { default as output3RdSeZcQaoMeta } from "/opt/buildhome/repo/frontend/pages/output.vue?macro=true";
import { default as scaledb2D72iofG4Meta } from "/opt/buildhome/repo/frontend/pages/scaled.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/frontend/pages/index.vue")
  },
  {
    name: "output",
    path: "/output",
    component: () => import("/opt/buildhome/repo/frontend/pages/output.vue")
  },
  {
    name: "scaled",
    path: "/scaled",
    component: () => import("/opt/buildhome/repo/frontend/pages/scaled.vue")
  }
]